import { styled } from 'styled-components';
import { COLORS, computeRemSize } from '@ydistri/theme';

/**
 * Mirrors `MenuNavLink` from `@ydistri/ds` so the trigger reads as a normal left-menu item, not a
 * separate widget - a `button`, not a `NavLink`, because there is no route to navigate to.
 */
export const YbotTriggerButton = styled.button<{ $isSelected: boolean }>`
  width: 100%;
  height: ${computeRemSize(90)};
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: center;
  justify-content: center;
  transition: ${p => p.theme.item.transition};

  border: none;
  border-right: 0.25rem solid transparent;
  border-left: 0.25rem solid transparent;
  background: transparent;
  cursor: pointer;

  padding: 0.75rem 0.5rem 0.75rem 0.5rem;
  color: ${COLORS.MENU_TEXT_COLOR};

  &:hover {
    ${p => !p.$isSelected && `background-color: ${p.theme.item.hovered.backgroundColorDark};`}
    color: white;
  }

  ${p =>
    p.$isSelected &&
    `
      background-color: ${p.theme.item.selected.backgroundColorDark};
      color: white;
      border-left-color: ${COLORS.PRIMARY};
    `}
`;
